import { createStore } from 'vuex'

// const URL = 'http://localhost:5005/';
const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';
var UNIT = 'i33wtiawk2hhdo16';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url: {
      URL_APP_SIMPEG: URL_SIMPEG, 
      URL_APP: URL,
      URL_SLIDER: URL + 'api/v1/publish_rsud_slider/',
      URL_BERITA: URL + 'api/v1/web_publish_berita/',
      URL_SAMBUTAN: URL + 'api/v1/publish_rsud_sambutan/',
      URL_LINK_TERKAIT: URL + 'api/v1/web_publish_link_terkait/',
      URL_FOTO: URL + 'api/v1/publish_rsud_foto/',
      URL_DOKTER_RSUD: URL + 'api/v1/publish_rsud_dokter/',
      URL_BUKU_PROFIL: URL + 'api/v1/publish_rsud_buku_profil/',
      URL_TENTANG_KAMI: URL + 'api/v1/publish_rsud_tentang_kami/',
      URL_TUGAS_POKOK: URL + 'api/v1/publish_rsud_tupoksi/',
      URL_VISI_MISI: URL + 'api/v1/publish_rsud_visi_misi/',
      URL_STRUKTUR_ORGANISASI: URL + 'api/v1/publish_rsud_struktur_organisasi/',
      URL_ALUR_PELAYANAN: URL + 'api/v1/publish_rsud_alur_pelayanan/',
      URL_PELAYANAN_KESEHATAN: URL + 'api/v1/publish_rsud_pelayanan_kesehatan/',
      URL_SARANA_PRASARANA: URL + 'api/v1/publish_rsud_sarana_prasarana/',
      URL_STANDAR_PELAYANAN: URL + 'api/v1/publish_rsud_standar_pelayanan/',
      URL_PRODUKSI_BENIH: URL + 'api/v1/publish_rsud_produksi_benih/',
      URL_DATA: URL + 'api/v1/publish_rsud_data/',
      URL_DOKUMEN_PERENCANAAN: URL + 'api/v1/publish_rsud_dokumen_perencanaan/',
      URL_VIDEO: URL + 'api/v1/publish_rsud_video/',
      URL_PERPUSTAKAAN_DIGITAL: URL + 'api/v1/publish_rsud_perpustakaan_digital/',
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
